/* eslint-disable no-unused-vars */
import {
  deriveOptionCodesFromProduct, getIsOutOfStock, getSelctedProduct 
} from "@/util/productFullDetailUtil";
import {
  create 
} from "zustand";
import type {
  OptionsSelectionsMap 
} from "../lib/get-optionSelections";
import {
  ProductRoot 
} from "../types/product";

interface ProductFullDetailState {
    isWeddingShoes: (product: any) => boolean;
    getOptions: (product: any) => any[];
    getEstimateDelivery: (product: any) => any[];
    getOptionCode: (product: ProductRoot) => any; // 添加这个方法
    getIsOutOfStock: (product: ProductRoot, optionSelections: OptionsSelectionsMap) => boolean; // 添加这个方法
    getSelectedProduct: (product: ProductRoot, optionSelections: OptionsSelectionsMap) => any; // 添加这个方法
    suggestedProductsColor: string;
    setSuggestedProductsColor: (color: string) => void;
    showMobileCustomlizeDialog: boolean;
    setShowMobileCustomlizeDialog: (payload: boolean) => void;
}

export const useProductFullDetailStore = create<ProductFullDetailState>((set, get) => ({
  isWeddingShoes: (product) => product?.categories?.[0]?.uid === "MTYy",
  getOptions: (product) => {
    if (product.__typename === "SimpleProduct") {
      return product.ampProtOption?.items || []
    }

    return product.configurable_options || []
  },
  getEstimateDelivery: (product) => {
    return product.show_attribute.filter((item: any) => item.label == "Tailoring Time")
  },
  getOptionCode: (product: ProductRoot) => {
    return deriveOptionCodesFromProduct(product)
  },
  getIsOutOfStock: (product: ProductRoot, optionSelections: OptionsSelectionsMap) => {
    const optionCodes = get().getOptionCode(product);

    return getIsOutOfStock(product, optionCodes, optionSelections);
  },
  getSelectedProduct: (product: ProductRoot, optionSelections: OptionsSelectionsMap) => {
    const optionCodes = get().getOptionCode(product)

    return getSelctedProduct(product, optionCodes, optionSelections);
  },
  suggestedProductsColor: "",
  setSuggestedProductsColor: (color: string) => set({
    suggestedProductsColor: color 
  }),
  showMobileCustomlizeDialog: false,
  setShowMobileCustomlizeDialog: (payload: boolean) => set({
    showMobileCustomlizeDialog: payload 
  }),
}));
